/**
 * Dev-only helper for the Media tab (CompositionItem).
 * Enable with REACT_APP_MOCK_MEDIA_DEPS=true in .env.local
 */

const isMediaModuleRow = (row) => row?.module?.heightLocation !== "TOP";

const hasParentLink = (row) => row?.dependentModuleComposition != null;

/**
 * For modules without dependentModuleComposition from API, links each next module
 * to the previous one in the same sideBaseModule group (parent ref on dependent row).
 */
export const applyMediaDependentMocks = (modules) => {
    if (process.env.REACT_APP_MOCK_MEDIA_DEPS !== "true") {
        return modules;
    }

    const list = Array.isArray(modules) ? modules.map((row) => ({...row})) : [];
    const mediaRows = list.filter(isMediaModuleRow);
    if (mediaRows.length < 2) {
        return list;
    }

    const bySide = {};
    for (const row of mediaRows) {
        const side = row.sideBaseModule ?? "UNKNOWN";
        if (!bySide[side]) {
            bySide[side] = [];
        }
        bySide[side].push(row);
    }

    for (const sideRows of Object.values(bySide)) {
        for (let i = 0; i < sideRows.length - 1; i++) {
            const primary = sideRows[i];
            const dependent = sideRows[i + 1];
            if (hasParentLink(dependent)) {
                continue;
            }
            const index = list.findIndex((m) => m.id === dependent.id);
            if (index >= 0) {
                list[index] = {
                    ...list[index],
                    dependentModuleComposition: {
                        moduleComposition: {id: primary.id},
                    },
                };
            }
        }
    }

    return list;
};
